import React, { useState } from 'react';
import InnerHaeder from '../Component/InnerHaeder';
import Highlights from '../Component/Highlights';
import Footer from '../Component/Footer';
import { Link } from 'react-router-dom';
import HeadTag from '../Component/HeadTags';
import LazyLoad from 'react-lazyload';

const Media = () => {
  const [selectedYear, setSelectedYear] = useState('2025');
  const [selectedMonth, setSelectedMonth] = useState('');

  const years = ['2025', '2024','2023', '2022',  '2020', '2019', '2018'];
  const months = [
    { name: 'January', value: '01' },
    { name: 'February', value: '02' },
    { name: 'March', value: '03' },
    { name: 'April', value: '04' },
    { name: 'May', value: '05' },
    { name: 'June', value: '06' },
    { name: 'July', value: '07' },
    { name: 'August', value: '08' },
    { name: 'September', value: '09' },
    { name: 'October', value: '10' },
    { name: 'November', value: '11' },
    { name: 'December', value: '12' }
  ];

  const mediaData = [
    { id: 0, title: 'Noida Times', date: '2025-03-03', imgSrc: 'https://webapi.entab.info/api/image/LVISGN/public/Images/media03-03-2025.jpg' },
    { id: 1, title: 'Hindustan Times', date: '2024-12-27', imgSrc: 'https://webapi.entab.info/api/image/LVISGN/public/Images/media27-12-2024.jpg' },
    { id: 2, title: 'Noida Times', date: '2024-12-26', imgSrc: 'https://webapi.entab.info/api/image/LVISGN/public/Images/media26-12-2024.jpg' },
    { id: 3, title: 'Times of India', date: '2024-12-10', imgSrc: 'https://webapi.entab.info/api/image/LVISGN/public/Images/media10-12-2024.jpg' },
    { id: 4, title: 'Times of India', date: '2024-12-05', imgSrc: 'https://webapi.entab.info/api/image/LVISGN/public/Images/media05-12-2024.jpg' },
    { id: 5, title: 'Times of India', date: '2024-11-14', imgSrc: 'https://webapi.entab.info/api/image/LVISGN/public/Images/media14-11-2024.jpg' },
    { id: 6 ,title: 'Amar Ujala', date: '2024-10-15', imgSrc: 'https://webapi.entab.info/api/image/LVISGN/public/Images/media15-10-2024-1.jpg' },
    { id: 7, title: 'Navbharat Times', date: '2024-09-19', imgSrc: 'https://webapi.entab.info/api/image/LVISGN/public/Images/media20-9-2024-1.jpg' },
    { id: 8, title: 'Hindustan Times', date: '2024-09-17', imgSrc: 'https://webapi.entab.info/api/image/LVISGN/public/Images/media17-9-2024-1.jpg' },
    { id: 9, title: 'Navbharat Times', date: '2024-09-17', imgSrc: 'https://webapi.entab.info/api/image/LVISGN/public/Images/media17-9-2024-2.jpg' },
    { id: 10, title: 'Navbharat Times', date: '2024-09-10', imgSrc: 'https://webapi.entab.info/api/image/LVISGN/public/Images/media17-9-2024-3.jpg' },
    { id: 11, title: 'Hindustan Times', date: '2024-09-12', imgSrc: 'https://webapi.entab.info/api/image/LVISGN/public/Images/media2024-09-10.png' },
    { id: 12, title: 'Times Of India', date: '2024-08-12', imgSrc: 'https://webapi.entab.info/api/image/LVISGN/public/Images/media2024-08-17.jpg' },
    { id: 13, title: 'Hindustan Times', date: '2024-08-10', imgSrc: 'https://webapi.entab.info/api/image/LVISGN/public/Images/media2024-08-12-2.jpg' },
    // { i13d: 8, title: 'Navbharat Times', date: '2024-08-10', imgSrc: 'https://webapi.entab.info/api/image/LVISGN/public/Images/media2024-08-12.jpg' },
    { id: 14, title: 'Navbharat Times', date: '2024-08-10', imgSrc: 'https://webapi.entab.info/api/image/LVISGN/public/Images/media2024-08-10.jpg' },
    { id: 15, title: 'Navbharat Times', date: '2024-08-02', imgSrc: 'https://webapi.entab.info/api/image/LVISGN/public/Images/media2024-08-02.jpg' },
    { id: 16, title: 'Amar Ujala', date: '2024-06-28', imgSrc: 'https://webapi.entab.info/api/image/LVISGN/public/Images/media2024-06-28.jpg' },
    { id: 17, title: 'Amar Ujala', date: '2024-06-28', imgSrc: 'https://webapi.entab.info/api/image/LVISGN/public/Images/media2024-06-24.jpg' },
    { id: 18, title: 'Navbharat Times', date: '2024-06-07', imgSrc: 'https://webapi.entab.info/api/image/LVISGN/public/Images/media2024-06-07.jpg' },
    { id: 19, title: 'Amar Ujala', date: '2024-04-21', imgSrc: 'https://webapi.entab.info/api/image/LVISGN/public/Images/media2024-04-21.jpg' },
    { id: 20, title: 'Navbharat Times', date: '2024-04-21', imgSrc: 'https://webapi.entab.info/api/image/LVISGN/public/Images/media2024-04-21-2.jpg' },
    { id: 21, title: 'Navbharat Times', date: '2024-02-17', imgSrc: 'https://webapi.entab.info/api/image/LVISGN/public/Images/media2024-02-17.jpg' },
    { id: 22, title: 'Navbharat Times', date: '2024-01-16', imgSrc: 'https://webapi.entab.info/api/image/LVISGN/public/Images/media2024-01-16.jpg' },
    { id: 23, title: 'Navbharat Times', date: '2024-01-06', imgSrc: 'https://webapi.entab.info/api/image/LVISGN/public/Images/media2024-01-01.jpg' },    
    { id: 24, title: 'Delhi Glow News', date: '2023-12-30', imgSrc: 'https://webapi.entab.info/api/image/LVISGN/public/Images/media-12-2023.jpg' },
    { id: 25, title: 'Amar Ujala', date: '2023-11-17', imgSrc: 'https://webapi.entab.info/api/image/LVISGN/public/Images/media-11-2023.jpg' },
    { id: 26, title: 'Navbharat Times', date: '2023-11-15', imgSrc: 'https://webapi.entab.info/api/image/LVISGN/public/Images/NBT-15-Nov-2023.jpg' },
    { id: 27, title: 'Navbharat Times', date: '2023-08-14', imgSrc: 'https://webapi.entab.info/api/image/LVISGN/public/Images/NBT-14-Aug-23.jpg' },
    { id: 28, title: 'Hindustan Times', date: '2023-06-01', imgSrc: 'https://webapi.entab.info/api/image/LVISGN/public/Images/NBT-Jun-23.jpg' },
    { id: 29, title: 'Navbharat Times', date: '2022-12-31', imgSrc: 'https://webapi.entab.info/api/image/LVISGN/public/Images/media-2022-12-31.jpg' },
    { id: 30, title: 'Amar Ujala', date: '2022-12-16', imgSrc: 'https://webapi.entab.info/api/image/LVISGN/public/Images/media-2022-12-16.jpg' },
    { id: 31, title: 'Navbharat Times', date: '2022-12-11', imgSrc: 'https://webapi.entab.info/api/image/LVISGN/public/Images/media-2022-11-11.jpg' },
    { id: 32, title: 'Navbharat Times', date: '2022-05-14', imgSrc: 'https://webapi.entab.info/api/image/LVISGN/public/Images/media-2022-05-14.jpg' },
    { id: 33, title: 'Hindustan Times', date: '2020-03-03', imgSrc: 'https://webapi.entab.info/api/image/LVISGN/public/Images/Media-03-03-2020-1.jpg' },
    { id: 34, title: 'Hindustan Times', date: '2020-03-02', imgSrc: 'https://webapi.entab.info/api/image/LVISGN/public/Images/Media-03-03-2020-2.jpg' },
    { id: 35, title: 'Amar Ujala', date: '2020-02-06', imgSrc: 'https://webapi.entab.info/api/image/LVISGN/public/Images/media-2022-05-14.jpg' },
    { id: 36, title: 'Hindustan Times', date: '2020-01-27', imgSrc: 'https://webapi.entab.info/api/image/LVISGN/public/Images/Media-03-03-2020-3.jpg' },
    { id: 37, title: 'Amar Ujala', date: '2019-09-01', imgSrc: 'https://webapi.entab.info/api/image/LVISGN/public/Images/Media-2019-09-01.jpg' },
    { id: 38, title: 'Amar Ujala', date: '2019-09-13', imgSrc: 'https://webapi.entab.info/api/image/LVISGN/public/Images/Media-2019-09-13.jpg' },
    { id: 39, title: 'Dainik Jagran', date: '2019-09-13', imgSrc: 'https://webapi.entab.info/api/image/LVISGN/public/Images/2019-09-13-2.jpg' },
    { id: 40, title: 'Hindustan Times', date: '2019-07-29', imgSrc: 'https://webapi.entab.info/api/image/LVISGN/public/Images/Media-2019-07-29.jpg' },
    { id: 41, title: 'Hindustan Times', date: '2018-12-24', imgSrc: 'https://webapi.entab.info/api/image/LVISGN/public/Images/Media-04-02-19.jpg' },
    { id: 42, title: 'Hindustan Times', date: '2018-12-24', imgSrc: 'https://webapi.entab.info/api/image/LVISGN/public/Images/Media-2018-12-18.jpg' },
    { id: 43, title: 'The Pioneer', date: '2018-03-28', imgSrc: 'https://webapi.entab.info/api/image/LVISGN/public/Images/Media.jpg' }
  ];


  // Filter media items based on selected year and month
  const filteredMedia = mediaData.filter((item) => {
    const mediaYear = item.date.split('-')[0];
    const mediaMonth = item.date.split('-')[1];
    return (
      (!selectedYear || mediaYear === selectedYear) &&
      (!selectedMonth || mediaMonth === selectedMonth)
    );
  });

  // Get available months based on the selected year
  const availableMonths = months.filter((month) =>
    mediaData.some((item) => {
      const mediaYear = item.date.split('-')[0];
      const mediaMonth = item.date.split('-')[1];
      return mediaYear === selectedYear && mediaMonth === month.value;
    })
  );

  return (
    <>
      <HeadTag title="Media" />
      <Highlights />
      <InnerHaeder />
      <div className="inner_page">
        <div className="container-fluid flwidth">
          <div className="bgimage">
            <h5>
              <Link to="/"> Home <i className="fas fa-angle-right"></i> </Link>
              <span> Gallery <i className="fas fa-angle-right"></i> Media </span>
            </h5>
            <h2>Media</h2>
          </div>

          {/* Year Selection */}
          <div className="filter-section">
            <div className="row">
             
              <div className="col-md-12"> 
                <select value={selectedYear} onChange={(e) => {setSelectedYear(e.target.value);
                   setSelectedMonth('');}}>
                  {years.map((year, index) => (
                    <option key={index} value={year}>
                    Year   {year}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            {/* Month Tabs */}
          
          </div>

          <div className="row img_data_sec media-img">
            {filteredMedia.length > 0 ? (
              filteredMedia.map((item) => (
                <div className="col-xl-3 col-lg-4 col-md-6" key={item.id}>
                  <div className="box">
                    <a data-magnify="gallery" data-src="" data-group="a" href={item.imgSrc}>
                     <LazyLoad><img src={item.imgSrc} className="img-fluid" alt={item.title} /></LazyLoad> 
                    </a>
                    <h4>{item.title}</h4>
                    <p><i class="bi bi-calendar-week"></i> {item.date}</p>
                  </div>
                </div>
              ))
            ) : (
              <div className="col-md-12">
                <p>No media found for the selected filters.</p>
              </div>
            )}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Media;
